import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { InputField } from "../../../../Components/formElements/InputField";

import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import FileUploadComponent from "../../../../Components/formElements/FileUploadComponent";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import ItemServiceV2 from "../../../../services/logistics_appCommonService";
import toast from "react-hot-toast";
import ItemServiceCustomer from "../../../../services/customer_appCommonService";

//Redux
import { useDispatch } from "react-redux";
import {
  getTodaysData,
  isValidNumber,
  validateContactNumber,
  validateName,
  validateRequired,
} from "../../../../common/Validations";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
import { getOrderSchedulingList } from "../../../../redux/feature/customer_app/customerV1Slice";

const message = {
  VALID_CUSTOMER_NAME: "Special characters or numbers are not allowed.",
  VALID_MAIL_ID: "Please enter a valid email address.",
  VALID_ALTERNATE_MAIL_ID: "Please enter a valid alternate email address.",
  VALID_CONTACT_NUMBER: "Please enter a valid contact number.",
  VALID_ALTERNATE_CONTACT_NUMBER:
    "Please enter a valid alternate contact number.",
  VALID_PURPOSE_JUSTIFICATION:
    "Please ensure the justification is under 500 characters.",
  VALID_POSTAL_CODE:
    "Enter a 6-character postal code with uppercase letters and numbers only",
  VALID_CONTACT_FIRST_NAME: "Special characters and numbers are not allowed",
  VALID_CONTACT_LAST_NAME: "Special characters and numbers are not allowed",
  EXIStS_MAIL_ID: "Email already exists",
  EXIStS_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_MAIL_ID: "Alternate Contact Number already exists",
  FILL_REQUIRED_FIELD: "Please fill the required field",
  ALTERNATE_MAIL_ID: "Email ID is same",
  ALTERNATE_CONTACT_NUMBER: "Contact number is same",
};

const PlFuelEntryModal = React.forwardRef((props, ref) => {
  const dispatch = useDispatch();
  const [disabled, setDisabled] = useState(false);
  const [getDropdownData, setDropdownData] = useState("");

  // View attachment files
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  /* pop failure modal data*/
  const FailureFuelEntry = {
    title: "Warning",
    ErrorMsg: "",
  };

  const [getFailureFuelEntry] = useState(FailureFuelEntry);

  const [getErrorFields, setErrorFields] = useState([]);
  const [getShowFailureModal, setShowFailureFuelEntry] = useState(false);

  // const [getDriveBankDetails, setDriveBankDetails] = useState([]);
  const [driverName1Desc, setDriverName1Desc] = useState("");

  const [formInputs, setFormInputs] = useState({
    filledDate: getTodaysData() || "",
    truckNo: "",
    driverName: "",
    driverContactNr: "",
    bunk: "",
    type: "",
    liters: "",
    price: "",
    totalAmount: "",
    paymentMode: "",
    // odometerReading: "",
    km: "",
    mileage: "",
    billDocument: "",
    oldReading: "",
    newReading: "",
    usageReading: "",
    fuelEnteryModal: "FUELUPDATED",
  });
  const FuelType = [
    { id: 1, name: "Petrol" },
    { id: 2, name: "Diesel" },
  ];
  const PaymentMode = [
    { id: 1, name: "Cash" },
    { id: 2, name: "UPI" },
    { id: 3, name: "Cards(Debit/Credit)" },
  ];

  const bunk = [
    { id: 1, name: "Basaveshwara Fuels" },
    { id: 2, name: "HNS Fuel" },
    { id: 2, name: "RK Fuels" },
  ];

  // For Upload Success
  const onSuccessUploadDocumentType = (data) => {
    setFormInputs((formInputs) => ({
      ...formInputs,
      [data.fieldName]: data.attachmentId,
    }));
  };

  useEffect(() => {
    if (!getDropdownData) return;
    // console.log(">>getDropdownData", getDropdownData);
    const updatedFields = {
      [getDropdownData?.textField]: getDropdownData?.name,
      [getDropdownData?.textCode]: getDropdownData?.textCode,
      [getDropdownData?.textDesc]: getDropdownData?.textDesc,
    };

    if (getDropdownData?.textField === "type") {
      updatedFields.type = getDropdownData?.name;
      updatedFields.type = getDropdownData?.name;
    }
    if (getDropdownData?.textField === "bunk") {
      updatedFields.bunk = getDropdownData?.name;
      updatedFields.bunk = getDropdownData?.name;
    }
    if (getDropdownData?.textField === "paymentMode") {
      updatedFields.paymentMode = getDropdownData?.name;
      updatedFields.paymentMode = getDropdownData?.name;
    }
    if (getDropdownData?.textField === "driverName") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.id,
        [getDropdownData?.textDesc]: getDropdownData?.description,
        getDriveBankDetails:getDropdownData?.bandkDetails,
         customer:getDropdownData?.code,
         customerCode:getDropdownData?.id,
         customerCodeDesc:getDropdownData?.name,
  
      }));
      // setDriveBankDetails(getDropdownData?.bandkDetails);
      setDriverName1Desc(getDropdownData?.id);
    }

    setFormInputs((prev) => ({
      ...prev,
      ...updatedFields,
    }));
    // eslint-disable-next-line
  }, [getDropdownData]);

  //Validations
  const [validation, setValidation] = useState({
    filledDate: "",
    truckNo: "",
    driverName: "",
    driverContactNr: "",
    bunk: "",
    fuelType: "",
    paymentMode: "",
    liters: "",
    price: "",
    odometerReading: "",
    km: "",
    mileage: "",
    billDocument: "",
    totalAmount: "",
    oldReading: "",
    newReading: "",
    usageReading: "",
  });
  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  const handleInputChange = ({ target: { name, value } }) => {
    // Real-time validation
    let error = "";
    switch (name) {
      case "truckNo":
        if (!validateRequired(value)) error = message.FILL_REQUIRED_FIELD;
        break;
      case "driverName":
        if (!validateName(value)) error = message.VALID_CUSTOMER_NAME;
        break;
      case "liters":
      case "price":
      case "oldReading":
      case "newReading":
      case "km":
        if (!isValidNumber(value)) error = message.FILL_REQUIRED_FIELD;
        break;
      case "driverContactNr":
        if (!validateContactNumber(value)) error = message.VALID_CONTACT_NUMBER;
        break;
      default:
        break;
    }

    // Update form input values
    setFormInputs((prevInputs) => {
      const updatedInputs = { ...prevInputs, [name]: value };

      if (updatedInputs.liters && updatedInputs.price) {
        updatedInputs.totalAmount =
          Number(updatedInputs.liters) * Number(updatedInputs.price);
      } else {
        updatedInputs.totalAmount = "";
      }

      if (updatedInputs.oldReading && updatedInputs.newReading) {
        updatedInputs.usageReading =
          Number(updatedInputs.newReading) - Number(updatedInputs.oldReading);
      } else {
        updatedInputs.usageReading = "";
      }

      if (updatedInputs.usageReading && updatedInputs.liters) {
        updatedInputs.mileage =
          Number(updatedInputs.usageReading) / Number(updatedInputs.liters);
      } else {
        updatedInputs.mileage = "";
      }

      return updatedInputs;
    });

    setValidation((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);

  const initialState = {
    truckNo: "",
    driverName: "",
    driverContactNr: "",
    bunk: "",
    type: "",
    paymentMode: "",
    liters: "",
    price: "",
    totalAmount: "",
    // odometerReading: "",
    km: "",
    mileage: "",
    billDocument: "",
    oldReading: "",
    newReading: "",
    usageReading: "",
  };

  //handle cancel modal
  const handleCancel = () => {
    setFormInputs((prev) => ({ ...prev, ...initialState }));

    props.onHide();
  };

  const handleSave = async () => {
    const requiredFields = [];
    const anyFieldNotEmpty = Object.values(validation).some(
      (value) => value !== null && value !== ""
    );
    if (anyFieldNotEmpty) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      return;
    }
    // if (!validateRequired(formInputs.truckNo)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureFuelEntry(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     truckNo: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.driverName)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureFuelEntry(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     driverName: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateName(formInputs.driverName)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureFuelEntry(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     driverName: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    if (!validateRequired(formInputs.driverContactNr)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureFuelEntry(true);
      setValidation((prev) => ({
        ...prev,
        driverContactNr: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateContactNumber(formInputs.driverContactNr)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureFuelEntry(true);
      setValidation((prev) => ({
        ...prev,
        driverContactNr: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.liters)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureFuelEntry(true);
      setValidation((prev) => ({
        ...prev,
        liters: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!isValidNumber(formInputs.liters)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureFuelEntry(true);
      setValidation((prev) => ({
        ...prev,
        liters: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.price)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureFuelEntry(true);
      setValidation((prev) => ({
        ...prev,
        price: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!isValidNumber(formInputs.price)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureFuelEntry(true);
      setValidation((prev) => ({
        ...prev,
        price: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.oldReading)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureFuelEntry(true);
      setValidation((prev) => ({
        ...prev,
        oldReading: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }

    if (!isValidNumber(formInputs.oldReading)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureFuelEntry(true);
      setValidation((prev) => ({
        ...prev,
        oldReading: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.newReading)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureFuelEntry(true);
      setValidation((prev) => ({
        ...prev,
        newReading: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!isValidNumber(formInputs.newReading)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureFuelEntry(true);
      setValidation((prev) => ({
        ...prev,
        newReading: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.km)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureFuelEntry(true);
      setValidation((prev) => ({
        ...prev,
        km: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!isValidNumber(formInputs.km)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureFuelEntry(true);
      setValidation((prev) => ({
        ...prev,
        km: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }

    setFormInputs((prev) => ({
      ...prev,
      ...initialState,
      // getDriveBankDetails,
      driverName1Desc,
    }));

    let obj = {
      data: formInputs,
    };
    setDisabled(true);
    await ItemServiceV2.addLogisticsFuel(obj).then((item) => {
      if (item?.status === 200) {
        handleSearchFuncApi();
        toast.success(item?.message || "added successfully", {
          duration: 2000,
          position: "top-right",
        });

        props.onHide();
      } else {
        // setErrorMsg('*'+ item?.message);
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
      setDisabled(false);
    });
  };

  const hideFailureModal = () => {
    setShowFailureFuelEntry(false);
  };

  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "getFuelList",
      module: "CUSTOMER",
      page: 1,
      per_page: 10,
      searchTerm: "",
    };
    dispatch(getOrderSchedulingList(obj));
  };
  const [getTruckData, setTruckData] = useState();
  const [getDriverNames, setDriverNames] = useState();

  const loadData = async () => {
    let obj3 = {
      queryName: "get_vehicleRegistrationNr",
    };
    await ItemServiceCustomer.generateCustomerQuery(obj3).then((item) => {
      // console.log(">> item! title", item?.data);

      if (item?.status === 200 && Array.isArray(item?.data)) {
        // Map API data into the desired structure
        const formattedData = item.data.map((truck) => ({
          vehicleRegistrationNr: truck.vehicleRegistrationNr,
          id: truck.id,
          name: truck.name,
          code: truck.vehicleRegistrationNr,
          codeType: truck.vehicleRegistrationNr,
          description: truck.vehicleRegistrationNr,
        }));

        // Append "OTHERS" object
        const updatedData = [
          ...formattedData,
          {
            vehicleRegistrationNr: "000 - OTHERS",
            id: "000",
            name: "000 - OTHERS",
            codeType: "truckCode",
            code: "000",
            description: "OTHERS",
          },
        ];

        setTruckData(updatedData);
      } else {
        setTruckData([]);
        console.log(">> Error: Loading Company Code");
      }
    });

    let obj2 = {
      queryName: "get_driver_list",
    };
    await ItemServiceCustomer.generateCustomerQuery(obj2).then((item) => {
      // console.log(">> item! title", item);
      if (item?.status === 200) {
        setDriverNames(item.data || []);
      } else {
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });
  };

  useEffect(() => {
    loadData();
  }, []);
  return (
    // backdrop="static"
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="xl"
      ref={ref}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Fuel Entry</Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
        {/* Removed the two fields */}

        {/*03 */}
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                {/* <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible1 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility3}
                  ></i>
                </Col> */}
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">FE</span>
                </Col>

                <Col xs={4} md={4} lg={4}>
                  <span className="headerTitle"> Fuel Entry</span>
                  <span className="subHeaderTitle">Fuel Entry details</span>
                </Col>
              </Row>
            </h2>

            <div>
              <div className="accordion-body">
                <Row>
                  <Col xs={12} md={12} lg={12}>
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            type="date"
                            label="Filling Date"
                            name="filledDate"
                            id="filledDate"
                            value={formInputs?.filledDate}
                            onChange={handleInputChange}
                            // disabled={true}
                          />
                        </Col>
                        {(formInputs?.truckNo !== "000" ||
                          formInputs?.truckNo !== "") && (
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Truck No"
                              placeholder=""
                              data={getTruckData}
                              id="truckNo"
                              iconClassName="dropdownIcon"
                              name="truckNo"
                              code="truckNoCode"
                              description="truckNoDesc"
                              setValue={formInputs?.truckNo || ""}
                              getvalue={setDropdownData}
                              required={true}
                              // error={validation.vehicleNr}
                            />
                          </Col>
                        )}
                        {formInputs?.truckNo === "000" && (
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Truck No"
                              name="truckNo"
                              placeholder=""
                              value={formInputs?.truckNo || ""}
                              onChange={handleInputChange}
                              required={true}
                            />
                          </Col>
                        )}
                        {/*  <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Truck No"
                            placeholder=""
                            name="truckNo"
                            id="truckNo"
                            value={formInputs?.truckNo || ""}
                            error={validation.truckNo || ""}
                            onChange={handleInputChange}
                            // disabled={true}
                            required={true}
                          />
                        </Col> */}
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            label="Driver Name"
                            placeholder=""
                            data={getDriverNames}
                            id="driverName"
                            iconClassName="dropdownIcon"
                            name="driverName"
                            code="driverNameCode"
                            description="driverNameDesc"
                            setValue={formInputs.driverName || ""}
                            getvalue={setDropdownData}
                            required={true}
                            error={validation.driverName}
                          />

                          {/* <InputField
                            className="inputBox"
                            label="Driver Name"
                            placeholder=""
                            name="driverName"
                            id="driverName"
                            error={validation.driverName || ""}
                            value={formInputs?.driverName || ""}
                            onChange={handleInputChange}
                          /> */}
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Driver Contact Nr"
                            placeholder=""
                            name="driverContactNr"
                            id="driverContactNr"
                            error={validation.driverContactNr || ""}
                            value={formInputs?.driverContactNr || ""}
                            onChange={handleInputChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <ComboboxField
                            label="Bunk Name"
                            placeholder=""
                            data={bunk}
                            id=""
                            iconClassName="dropdownIcon"
                            name="bunk"
                            code="bunkCode"
                            description="bunkDesc"
                            setValue={formInputs?.bunk}
                            getvalue={setDropdownData}
                            required={true}
                            // error={validation.country}
                            // disabled={editMode}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <ComboboxField
                            label="Fuel Type"
                            placeholder=""
                            data={FuelType}
                            id=""
                            iconClassName="dropdownIcon"
                            name="fuelType"
                            code="fuelTypeCode"
                            description="fuelTypeDesc"
                            setValue={formInputs?.fuelType}
                            getvalue={setDropdownData}
                            required={true}
                            // error={validation.country}
                            // disabled={editMode}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Liters"
                            placeholder=""
                            name="liters"
                            id="liters"
                            error={validation.liters || ""}
                            value={formInputs?.liters || ""}
                            onChange={handleInputChange}
                            required={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Fuel Price"
                            placeholder=""
                            name="price"
                            id="price"
                            error={validation.price || ""}
                            value={formInputs?.price || ""}
                            onChange={handleInputChange}
                            required={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Total Amount"
                            placeholder=""
                            name="totalAmount"
                            id="totalAmount"
                            value={formInputs?.totalAmount || ""}
                            readOnly={true} // make it read-only since it’s calculated
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <ComboboxField
                            label="Payment Mode"
                            placeholder=""
                            data={PaymentMode}
                            id=""
                            iconClassName="dropdownIcon"
                            name="paymentMode"
                            code="paymentMode"
                            description="paymentMode"
                            setValue={formInputs?.paymentMode}
                            getvalue={setDropdownData}
                            required={true}
                            // error={validation.country}
                            // disabled={editMode}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Old Reading"
                            placeholder=""
                            name="oldReading"
                            id="oldReading"
                            error={validation.oldReading || ""}
                            value={formInputs?.oldReading || ""}
                            onChange={handleInputChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="New Reading"
                            placeholder=""
                            name="newReading"
                            id="newReading"
                            error={validation.newReading || ""}
                            value={formInputs?.newReading || ""}
                            onChange={handleInputChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Usage Reading"
                            placeholder=""
                            name="usageReading"
                            id="usageReading"
                            error={validation.usageReading || ""}
                            value={formInputs?.usageReading || ""}
                            onChange={handleInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Mileage"
                            placeholder=""
                            name="mileage"
                            id="mileage"
                            value={formInputs?.mileage || ""}
                            readOnly={true}
                            disabled={true}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Kilo Meter"
                            placeholder=""
                            name="km"
                            id="km"
                            error={validation.km || ""}
                            value={formInputs?.km || ""}
                            onChange={handleInputChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={12}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <FileUploadComponent
                            id="billDocument"
                            name="billDocument"
                            label="Supporting Document"
                            allowedTypes={[
                              "image/png",
                              "image/jpeg",
                              "application/pdf",
                            ]}
                            multiple={true} // Change to false for single file selection
                            required={true}
                            onSuccessUpload={onSuccessUploadDocumentType}
                            value={formInputs?.billDocument || ""}
                          />
                        </Col>
                        <Col
                          xs={8}
                          md={2}
                          lg={2}
                          className="commLeftRightPadding"
                        >
                          {(formInputs?.billDocument && (
                            <img
                              src="assets/img/newIcons/attached-file.png"
                              className="mt-1 attachmentIcon"
                              alt="attachments"
                              onClick={() =>
                                handleViewFile(formInputs?.billDocument)
                              }
                            />
                          )) ||
                            "--"}
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
            {
              <Row className="my-4 ">
                <Col
                  lg={{ span: 2, offset: 8 }}
                  className="d-flex justify-content-end mt-2"
                >
                  <button
                    className="btnTable btn-danger"
                    onClick={handleCancel}
                    disabled={disabled}
                  >
                    Cancel
                  </button>
                </Col>
                <Col lg={2} className="d-flex justify-content-end mt-2">
                  <button
                    className="btnTable"
                    disabled={disabled}
                    onClick={handleSave}
                  >
                    Save
                  </button>
                </Col>
              </Row>
            }
          </div>
        </div>
        <FileViewerModal
          show={getShowFileViewModal}
          onHide={handleViewFileHide}
          fileid={getFileViewData}
        />
        <FailureModal
          show={getShowFailureModal}
          onHide={hideFailureModal}
          failureFuelData={getFailureFuelEntry}
          requiredfields={getErrorFields}
        />
      </Modal.Body>
    </Modal>
  );
});

export default PlFuelEntryModal;
